import React from 'react';
import injectSheet from 'react-jss';
import PropTypes from 'prop-types';
import SearchBtn from '../components/SearchBtn';
import FilterBtn from '../components/FilterBtn';

const styles = {
  wrapperHeader: {
    marginTop: '1.875rem',
    marginBottom: '1.875rem',
  },
  titleHeader: {
    fontFamily: 'Lato',
    fontSize: '1.75rem',
    color: '#1F1F1F',
    textAlign: 'center',
  },
  descriptionHeader: {
    fontFamily: 'Lato',
    fontSize: '0.875rem',
    color: '#979797',
    textAlign: 'center',
  },
  btnWrapper: {
    display: 'flex',
    // width: 'calc(100% - 85px)',
    // margin: '0 auto',
  },
  searchBtnContainer: {
    display: 'inline-block',
    width: 'calc(100% - 60px)',
  },
  filterBtnContainer: {
    display: 'inline-block',
    width: '60px',
  },
};

const IssueJam = (props) => {
  const {
 classes, titleHeader, descriptionHeader, showBtns, descriptionHeader2,
} = props;
  return (
    <div className={classes.wrapperHeader}>
      <div className={classes.titleHeader}>
        {titleHeader}
      </div>
      <div className={classes.descriptionHeader}>
        {descriptionHeader}
      </div>
      <div className={classes.descriptionHeader}>
        {descriptionHeader2}
      </div>
      {showBtns
        ? (
          <div className={classes.btnWrapper}>
            <div className={classes.searchBtnContainer}>
              <SearchBtn />
            </div>
            <div className={classes.filterBtnContainer}>
              <FilterBtn />
            </div>
          </div>) : ''}
    </div>
  );
};

IssueJam.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default injectSheet(styles)(IssueJam);



// WEBPACK FOOTER //
// ./src/pages/HeaderPage.js